import { FilterParams } from 'interfaces/filters';
import { PaginationParams } from 'interfaces/pagination';
import {
  IResponseGetCarriers,
  IHubCarrier,
  IHubAllCarrier,
} from 'interfaces/Hub';
import { applyQueryString } from 'lib/queryString';
import { apiHub } from 'services';
import { SelectContentProps } from 'components/ui/Forms';

export function useHubCarrier() {
  const webcol_id = process.env.REACT_APP_HUB_WEBCOL_ID;
  const getListCarriers = async (
    filters: FilterParams,
    pagination: PaginationParams
  ): Promise<any> => {
    const url = applyQueryString(`/carrier`, {
      ...filters,
      ...pagination,
	  webcol_id
    });
    const { data } = await apiHub.get<IResponseGetCarriers>(url);
    return data;
  };

  const fetchCarriers = async () => {
    const selectFields: Array<keyof IHubAllCarrier> = [
      'id',
      'trade_name',
      'document',
      'address_city',
      'address_state',
    ];

    const { data } = await apiHub.post<IHubAllCarrier[]>(`/carrier-all`, {
      selectFields,
      webcol_id,
    });

    const comboOptions: SelectContentProps[] = data.map((carrier: any) => ({
      name: `${carrier.trade_name} - ${carrier.address_city}/${carrier.address_state}`,
      value: carrier.id,
    }));

    return { comboOptions, data };
  };

  const createCarrier = async (data: Partial<IHubCarrier>): Promise<void> => {
    await apiHub.post('/carrier', { ...data, webcol_id });
  };

  const updateCarrier = async (data: Partial<IHubCarrier>): Promise<void> => {
    await apiHub.put(`/carrier/${data.id}`, data);
  };

  const deleteCarrier = async (id: number): Promise<void> => {
    await apiHub.delete(`/carrier/${id}`);
  };

  const getCarrier = async (id: string): Promise<void> => {
    const { data } = await apiHub.get(`/carrier/${id}`);
    return data;
  };

  return {
    getListCarriers,
    fetchCarriers,
    createCarrier,
    updateCarrier,
    deleteCarrier,
    getCarrier,
  };
}
